/* eslint-disable @typescript-eslint/no-unused-vars */

// // context/SidebarContext.js
// "use client";

// import { categories } from "@/components/Branch/CategoriesButtonComponent";
// import { GET } from "@/helpers/ApiConfig";
// import getUserLocation from "@/helpers/geoLocation";
// import { createContext, useContext, useEffect, useState } from "react";
// const GlobalContext = createContext();

// export const GlobalProvider = ({ children }) => {
//   const [isSidebarExpanded, setSidebarExpanded] = useState(false);

//   const [searchQuery, setSearchQuery] = useState("");
//   const [radius, setRadius] = useState(3);
//   const [user, setUser] = useState(null);
//   const [places, setPlaces] = useState([]);
//   const [selectedPlace, setSelectedPlace] = useState(null);
//   const [placeHighlight, setPlaceHighlight] = useState(null);
//   const [favourites, setFavourites] = useState([]);
//   const [apiLoading, setApiLoading] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [location, setLocation] = useState({
//     lat: null,
//     lng: null,
//   });
//   const [branchLocation, setBranchLocation] = useState({
//     lat: null,
//     lng: null,
//   });
//   const [allowAutoFetch, setAllowAutoFetch] = useState(false);
//   const [selectedBranch, setSelectedBranch] = useState("My Location");
//   const [regionBranchLocations, setRegionBranchLocations] = useState([]);
//   const [isBranchLocation, setIsBranchLocation] = useState(false);
//   const [selectedBusiness, setSelectedBusiness] = useState("");
//   const [upcomingVisits, setUpcomingVisits] = useState([]);

//   useEffect(() => {
//     const getBranchLocation = async (user) => {
//       try {
//         const res = await GET(`/branch/get/location/${user?.branchCode}`);
//         // const res = await GET("/branch/get/location/7682354762345")
//         if (res.data?.data?.isBranch == "N") {
//           return null;
//         }
//         const loc = {
//           lat: res?.data?.data?.latitude,
//           lng: res?.data?.data?.longitude,
//         };
//         console.log("LOCATION API ", location);
//         setLocation(loc);
//         setBranchLocation(loc);

//         return loc;
//       } catch (error) {
//         return null;
//       }
//     };
//     if (!user) return;
//     const fetchLocation = async () => {
//       if (!user) return;

//       // Await the result of getBranchLocation
//       const branchLocation = await getBranchLocation(user);

//       console.log("res Locationnnn -------- : ", branchLocation);

//       if (branchLocation?.lat) {
//         return; // If branchLocation exists, set it
//       } else {
//         console.log("LOCATION API BROWSER GEOOO", location);
//         // If no branchLocation, get user location
//         getUserLocation().then((loca) => {
//           console.log("User location: ", loca);
//           setLocation(loca);
//         });
//       }
//     };

//     fetchLocation();
//   }, [user]);

//   const resetMapPlaces = () => {
//     setPlaces([]);
//     setSelectedPlace(null);
//     setPlaceHighlight(null);
//   };

//   const handleCategory = (category) => {
//     categories.map((it) => {
//       //"CAtegory Matched : ", category)
//       it.value === category && setSelectedCategory(category);
//     });
//   };
//   //"user", user);
//   const resetState = () => {
//     //Reset all useStates
//     setSearchQuery("");
//     setRadius(3);
//     setUser(null);
//     setSidebarExpanded(false);
//     setPlaces([]);
//     setSelectedPlace(null);
//     setPlaceHighlight(null);
//     setFavourites([]);
//     setLocation({
//       lat: null,
//       lng: null,
//     });
//     setBranchLocation({
//       lat: null,
//       lng: null,
//     });
//     setSelectedCategory(null);
//     setSelectedBranch("My Location");
//     setRegionBranchLocations([]);
//   };

//   useEffect(() => {
//     const fetchVisits = async () => {
//       try {
//         const response = await GET(`/lead/get/visit/${user?.branchCode}`);
//         setUpcomingVisits(response?.data?.data);
//       } catch (error) {
//         console.error("Error fetching visits:", error);
//       }
//     };

//     if (user) {
//       fetchVisits();
//     }
//   }, [user]);

//   return (
//     <GlobalContext.Provider
//       value={{
//         isSidebarExpanded,
//         setSidebarExpanded,
//         searchQuery,
//         setSearchQuery,
//         places,
//         setPlaces,
//         selectedPlace,
//         setSelectedPlace,
//         placeHighlight,
//         setPlaceHighlight,
//         radius,
//         setRadius,
//         favourites,
//         setFavourites,
//         location,
//         setLocation,
//         user,
//         setUser,
//         resetState,
//         apiLoading,
//         setApiLoading,
//         selectedCategory,
//         setSelectedCategory,
//         handleCategory,
//         selectedBranch,
//         setSelectedBranch,
//         regionBranchLocations,
//         setRegionBranchLocations,
//         branchLocation,
//         resetMapPlaces,
//         isBranchLocation,
//         setIsBranchLocation,
//         selectedBusiness,
//         setSelectedBusiness,
//         upcomingVisits,
//         setUpcomingVisits,
//         allowAutoFetch,
//         setAllowAutoFetch,
//       }}
//     >
//       {children}
//     </GlobalContext.Provider>
//   );
// };

// export const GlobalData = () => useContext(GlobalContext);
// context/SidebarContext.js
"use client";

import { categories } from "@/components/Branch/CategoriesButtonComponent";
import { GET, POST } from "@/helpers/ApiConfig";
import getUserLocation from "@/helpers/geoLocation";
import { usePathname } from "next/navigation";
import { createContext, useContext, useEffect, useState } from "react";
const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [isSidebarExpanded, setSidebarExpanded] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [radius, setRadius] = useState(3);
  const [user, setUser] = useState(null);
  const [places, setPlaces] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState(null);

  const [selectedPlaceNavbar, setSelectedPlaceNavbar] = useState(null);
  const [placeHighlight, setPlaceHighlight] = useState(null);
  const [favourites, setFavourites] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [location, setLocation] = useState({
    lat: null,
    lng: null,
  });
  const [branchLocation, setBranchLocation] = useState({
    lat: null,
    lng: null,
  });

  const [allowAutoFetch, setAllowAutoFetch] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState("My Location");
  const [regionBranchLocations, setRegionBranchLocations] = useState([]);
  const [isBranchLocation, setIsBranchLocation] = useState(false);
  const [selectedBusiness, setSelectedBusiness] = useState("");
  const [upcomingVisits, setUpcomingVisits] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  const [refetchVisits, setRefetchVisits] = useState(false);

  useEffect(() => {
    const getBranchLocation = async (user) => {
      try {
        const res = await GET(`/branch/get/location/${user?.branchCode}`);
        // const res = await GET("/branch/get/location/7682354762345")
        if (res.data?.data?.isBranch == "N") {
          return null;
        }
        const loc = {
          lat: res?.data?.data?.latitude,
          lng: res?.data?.data?.longitude,
        };
        console.log("LOCATION API ", location);
        setLocation(loc);
        setBranchLocation(loc);
        setIsBranchLocation(true);
        return loc;
      } catch (error) {
        return null;
      }
    };
    if (!user) return;
    const fetchLocation = async () => {
      if (!user) return;

      // Await the result of getBranchLocation
      const branchLocation = await getBranchLocation(user);

      console.log("res Locationnnn -------- : ", branchLocation);

      if (branchLocation?.lat) {
        return; // If branchLocation exists, set it
      } else {
        console.log("LOCATION API BROWSER GEOOO", location);
        // If no branchLocation, get user location
        getUserLocation().then((loca) => {
          console.log("User location: ", loca);
          setLocation(loca);
        });
      }
    };

    fetchLocation();
  }, [user]);

  const resetMapPlaces = () => {
    setPlaces([]);
    setSelectedPlace(null);
    setPlaceHighlight(null);
  };

  const handleCategory = (category) => {
    categories.map((it) => {
      //"CAtegory Matched : ", category)
      it.value === category && setSelectedCategory(category);
    });
  };
  //"user", user);
  const resetState = () => {
    //Reset all useStates
    setSearchQuery("");
    setRadius(3);
    setUser(null);
    setSidebarExpanded(false);
    setPlaces([]);
    setSelectedPlace(null);
    setPlaceHighlight(null);
    setFavourites([]);
    setLocation({
      lat: null,
      lng: null,
    });
    setBranchLocation({
      lat: null,
      lng: null,
    });
    setSelectedCategory(null);
    setSelectedBranch("My Location");
    setRegionBranchLocations([]);
  };

  useEffect(() => {
    const fetchVisits = async () => {
      try {
        const response = await GET(`/lead/get/visit/${user?.branchCode}`);
        setUpcomingVisits(response?.data?.data);
      } catch (error) {
        console.error("Error fetching visits:", error);
      }
    };

    if (user) {
      fetchVisits();
    }
  }, [user, refetchVisits]);

  // Get Business Places //

  const pathname = usePathname();

  const structurePlaces = (places) => {
    const strData = [];
    //"UBSTRUCTURED PLACESSSSS : ", places)
    places?.forEach((pl) => {
      const {
        id,
        name,
        leads,
        details,
        rating,
        distance,
        distance_with_heversine,
        distance_with_vincenty,
        website,
        phone,
        address,
        latitude,
        longitude,
        bank_latitude,
        bank_longitude,
        opening_hours,
        image_url,
        created_date,
        modified_date,
        category,
        favourite,
        radius,
        googleMapsUri,
      } = pl;

      strData.push({
        id,
        photos: image_url ? [...image_url.split(", ")] : [],
        displayName: { text: name },
        rating,
        userRatingCount: "",
        primaryTypeDisplayName: { text: category },
        googleMapsUri,
        shortFormattedAddress: address,
        internationalPhoneNumber: phone,
        websiteUri: website,
        openingHours: opening_hours,
        location: { longitude, latitude },
        leads,
        favourite,
      });
    });
    return strData;
  };

  const fetchPlaces = async (
    type,
    search = "query",
    fetchLocation = location
  ) => {
    if (
      apiLoading ||
      user?.role == "GROUP" ||
      user?.role == "HEAD" ||
      !pathname.endsWith("map")
      // ||
      // !autoFetch
    ) {
      //"ALREADY LOADING")

      return;
    }

    const latitude = fetchLocation?.lat;
    const longitude = fetchLocation?.lng;
    if (type || (searchQuery && radius)) {
      try {
        setApiLoading(true);
        // toast.loading("Fetching Places");

        const response = await POST("/business/locations", {
          latitude: latitude,
          longitude: longitude,
          radius: radius,
          query: type || searchQuery,
          branch: user?.branchCode,
        });
        // toast.remove();
        const dataB = response?.data;
        console.log("RETURNED PLACES----------------- : ", dataB, type, "bbb,", searchQuery);
        console.log("LOCATION WHEN API CALled : ", apiLoading, user, type);
        if (dataB.length == 0) {
          toast.error("No Places Found for " + searchQuery);
          return;
        }
        if (response.status == 200 && typeof dataB !== "string") {
          // toast.success("Places Fetched Successfully");
        }

        if (response?.status !== 200) {
          throw new Error(`Error: ${response.statusText}`);
        }
        if (typeof dataB === "string") {
          throw new Error(response?.data);
        }

        const data = structurePlaces(dataB);
        setPlaces(data || []);
        // search == "query" && setSelectedCategory(null);
        handleCategory(type || searchQuery);
        // if (selectedPlace) setSelectedPlace(data[0]);
      } catch (error) {
        // toast.remove();
        console.error("Failed to fetch nearby places", error);
        // toast.error("Failed to fetch places");
      } finally {
        // toast.remove()
        setApiLoading(false);
        // setAllowAutoFetch(true);
      }
    }
  };

  // End Business Api //


  return (
    <GlobalContext.Provider
      value={{
        isSidebarExpanded,
        setSidebarExpanded,
        searchQuery,
        setSearchQuery,
        places,
        setPlaces,
        selectedPlace,
        setSelectedPlace,
        placeHighlight,
        setPlaceHighlight,
        radius,
        setRadius,
        favourites,
        setFavourites,
        location,
        setLocation,
        user,
        setUser,
        resetState,
        apiLoading,
        setApiLoading,
        selectedCategory,
        setSelectedCategory,
        handleCategory,
        selectedBranch,
        setSelectedBranch,
        regionBranchLocations,
        setRegionBranchLocations,
        branchLocation,
        resetMapPlaces,
        isBranchLocation,
        setIsBranchLocation,
        selectedBusiness,
        setSelectedBusiness,
        upcomingVisits,
        setUpcomingVisits,
        allowAutoFetch,
        setAllowAutoFetch,
        fetchPlaces,
        pageLoader,
        setPageLoader,
        setRefetchVisits,
        selectedPlaceNavbar,
        setSelectedPlaceNavbar
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const GlobalData = () => useContext(GlobalContext);
